import { eases } from "library/eases"
import { fresponsive } from "library/fullyResponsive"
import styled, { css, keyframes } from "styled-components"
import colors from "styles/colors"

export default function FacilitiesMore() {
	return (
		<Wrapper>
			<Rect />
			<Rect />
			<Rect />
			<Rect />
			<Rect />
		</Wrapper>
	)
}

const slide = keyframes`
    10% {
        translate: 0 0;
        animation-timing-function: ${eases.quart.inOut}
    }

    40% {
        translate: calc(-100% - var(--offset)) 0;
    }

    60% {
        translate: calc(-100% - var(--offset)) 0;
        animation-timing-function: ${eases.quart.inOut}
    }

    90% {
        translate: 0 0;
    }
`

const Wrapper = styled.div`
	animation: ${slide} 10s infinite;

	${fresponsive(css`
		padding: 16px;
		display: flex;
		gap: 8px;
		width: fit-content;
		--offset: -65px;
	`)}
`

const Rect = styled.div`
	border: 1px solid ${colors.blue3};

	${fresponsive(css`
		width: 32px;
		height: 32px;
		border-radius: 4px;
		flex-shrink: 0;
	`)}
`
